import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import { Observable } from 'rxjs';

import {
  fetchObjectToHttpRequest,
  fetchStringOrUrlToFetchObject,
} from './fetch-to-http-request';

@Injectable()
export class HttpProviderService implements AbstractDataProvider {
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Takes a 'fetch' string or simply a URL and executes it as a HTTP request.
   * To obtain a fetch string go to Chrome dev tools, network tab, and copy a request as fetch.
   * @param fetchStringOrUrl The string formatted in the same way as a fetch request.
   * @returns The result of the network request.
   */
  public read<T>(fetchStringOrUrl: string): Observable<T> {
    const fetchObject = fetchStringOrUrlToFetchObject(fetchStringOrUrl);
    const httpRequest = fetchObjectToHttpRequest(fetchObject);
    return this.httpClient.request<T>(httpRequest) as Observable<T>;
  }

  public write() {
    // for linter
  }
}
